import * as React from "react";
import { useMutation, useQueryClient } from "react-query";

import { Resource } from "../Services/ResourceService";

import { UseCRUD } from "./hookTypes";

function useDelete<T extends Resource, K extends Resource = T>({
  service,
  id,
}: UseCRUD<T>) {
  const queryClient = useQueryClient();

  const { mutateAsync: deleteOne, isLoading: isDeleting } = useMutation(
    (payload: T) => service.deleteOne(payload),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(service.getQueryKey());
      },
    }
  );

  return {
    deleteOne,
    isDeleting,
  };
}

export default useDelete;
